module.exports = __webpack_public_path__ + "img/22.17cb610c.jpg";